export enum Role {
  ADMIN = 'ROLE_ADMIN',
  BILLING = 'ROLE_BILLING',
  CONSULTANT = 'ROLE_CONSULTANT',
  CRM = 'ROLE_CRM',
}
